import LinearProgress from './LinearProgress';
import CircularProgress from './CircularProgress';

export { LinearProgress, CircularProgress };
export default LinearProgress;



// WEBPACK FOOTER //
// ./src/progress/index.js